import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import cache from '../../core/cache'
import {connectForm} from '../../core/redux/form'
import CardGroup from '../../core/components/CardGroup'
import {createValidator, OpenTicketCmd} from '../models'
import {OPEN_TICKET_CMD_UPDATED} from '../actions'
import OpenTicketCallerCard from './OpenTicketCallerCard'
import OpenTicketContactToCallbackCard from './OpenTicketContactToCallbackCard'
import OpenTicketAddressCard from './OpenTicketAddressCard'
import OpenTicketPurposeCard from './OpenTicketPurposeCard'
import OpenTicketRequestCard from './OpenTicketRequestCard'
import OpenTicketButtonToolbar from './OpenTicketButtonToolbar'

const schemaCache = cache()

function selectSchema(target, {step}) {
    const schema = OpenTicketCmd.selectSchema(target)

    return schemaCache([schema, step], () => {
        if (step == 0.1) {
            return {
                ...schema,
                properties: {
                    company: schema.properties.company,
                    locationRef: schema.properties.locationRef,
                    ticket: {
                        ...schema.properties.ticket,
                        properties: {
                            callerz: schema.properties.ticket.properties.callerz,
                            contactToCallback: schema.properties.ticket.properties.contactToCallback,
                            address: schema.properties.ticket.properties.address
                        },
                        required: ['callerz', 'address']
                    }
                },
                required: ['company', 'locationRef', 'ticket']
            }
        }
        return schema
    })
}

class OpenTicketLayout extends Component {
    static propTypes = {
        step: PropTypes.number.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    render() {
        const {dispatch, form, cmd, step, onSubmit, ...others} = this.props

        return (
            <div>
                <OpenTicketAddressCard split
                    dispatch={dispatch}
                    form={form}
                    cmd={cmd} />
                <Row>
                    <Col sm={6}>
                        <OpenTicketCallerCard
                            dispatch={dispatch}
                            form={form}
                            cmd={cmd} />
                    </Col>
                    <Col sm={6}>
                        <OpenTicketContactToCallbackCard
                            position='right'
                            dispatch={dispatch}
                            form={form}
                            cmd={cmd} />
                    </Col>
                </Row>
                {step == 0.2 && (
                    <div>
                        <OpenTicketPurposeCard
                            dispatch={dispatch}
                            form={form}
                            cmd={cmd} />
                        <CardGroup>
                            <OpenTicketRequestCard
                                dispatch={dispatch}
                                form={form}
                                cmd={cmd} />
                        </CardGroup>
                    </div>
                )}
                <OpenTicketButtonToolbar
                    dispatch={dispatch}
                    form={form}
                    cmd={cmd}
                    step={step}
                    onSubmit={onSubmit} />
            </div>
        )
    }
}

OpenTicketLayout = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: selectSchema,
    action: OPEN_TICKET_CMD_UPDATED
})(OpenTicketLayout)

OpenTicketLayout = connect((state) => ({
    cmd: state.ticket.openTicketCmd
}))(OpenTicketLayout)

export default OpenTicketLayout


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketLayout.js